import AccessTime from '@mui/icons-material/AccessTime';
import Add from '@mui/icons-material/Add';
import AddChartIcon from '@mui/icons-material/Addchart';
import AddCircleOutline from '@mui/icons-material/AddCircleOutline';
import AlarmOff from '@mui/icons-material/AlarmOff';
import AndroidFilled from '@mui/icons-material/Android';
import Announcement from '@mui/icons-material/Announcement';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import ArrowRight from '@mui/icons-material/ArrowRight';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import Archive from '@mui/icons-material/Archive';
import AutoAwesome from '@mui/icons-material/AutoAwesome';
import Unarchive from '@mui/icons-material/Unarchive';
import Assessment from '@mui/icons-material/Assessment';
import Ballot from '@mui/icons-material/Ballot';
import BarChart from '@mui/icons-material/BarChart';
import Block from '@mui/icons-material/Block';
import BorderColor from '@mui/icons-material/BorderColor';
import Cached from '@mui/icons-material/Cached';
import CameraAlt from '@mui/icons-material/CameraAlt';
import Cancel from '@mui/icons-material/Cancel';
import Chat from '@mui/icons-material/Chat';
import ChatBubbleOutline from '@mui/icons-material/ChatBubbleOutline';
import CheckBox from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlank from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckCircle from '@mui/icons-material/CheckCircle';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import ChevronRight from '@mui/icons-material/ChevronRight';
import Close from '@mui/icons-material/Close';
import ControlPointDuplicate from '@mui/icons-material/ControlPointDuplicate';
import Dashboard from '@mui/icons-material/Dashboard';
import DateRange from '@mui/icons-material/DateRange';
import Delete from '@mui/icons-material/Delete';
import Done from '@mui/icons-material/Done';
import DragIndicator from '@mui/icons-material/DragIndicator';
import Edit from '@mui/icons-material/Edit';
import EditOutlined from '@mui/icons-material/EditOutlined';
import Email from '@mui/icons-material/Email';
import Error from '@mui/icons-material/Error';
import ErrorOutline from '@mui/icons-material/ErrorOutline';
import ExitToApp from '@mui/icons-material/ExitToApp';
import FileCopy from '@mui/icons-material/FileCopy';
import FilterList from '@mui/icons-material/FilterList';
import GetApp from '@mui/icons-material/GetApp';
import Help from '@mui/icons-material/Help';
import Info from '@mui/icons-material/Info';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import InsertDriveFile from '@mui/icons-material/InsertDriveFile';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import Launch from '@mui/icons-material/Launch';
import LibraryAdd from '@mui/icons-material/LibraryAdd';
import LibraryAddCheck from '@mui/icons-material/LibraryAddCheck';
import LibraryBooks from '@mui/icons-material/LibraryBooks';
import ListAlt from '@mui/icons-material/ListAlt';
import LockOpen from '@mui/icons-material/LockOpen';
import NetworkCheck from '@mui/icons-material/NetworkCheck';
import NotificationsOff from '@mui/icons-material/NotificationsOff';
import Palette from '@mui/icons-material/Palette';
import People from '@mui/icons-material/People';
import PermContactCalendar from '@mui/icons-material/PermContactCalendar';
import Person from '@mui/icons-material/Person';
import PhoneDisabled from '@mui/icons-material/PhoneDisabled';
import Photo from '@mui/icons-material/Photo';
import PlaylistAdd from '@mui/icons-material/PlaylistAdd';
import Publish from '@mui/icons-material/Publish';
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import RemoveCircle from '@mui/icons-material/RemoveCircle';
import RemoveCircleOutline from '@mui/icons-material/RemoveCircleOutline';
import ReplayIcon from '@mui/icons-material/Replay';
import ReportProblemOutlined from '@mui/icons-material/ReportProblemOutlined';
import ReportProblem from '@mui/icons-material/ReportProblem';
import School from '@mui/icons-material/School';
import Search from '@mui/icons-material/Search';
import Security from '@mui/icons-material/Security';
import Send from '@mui/icons-material/Send';
import SentimentSatisfied from '@mui/icons-material/SentimentSatisfied';
import SentimentSatisfiedAlt from '@mui/icons-material/SentimentSatisfiedAlt';
import SentimentVeryDissatisfied from '@mui/icons-material/SentimentVeryDissatisfied';
import Settings from '@mui/icons-material/Settings';
import SettingsBackupRestore from '@mui/icons-material/SettingsBackupRestore';
import Sms from '@mui/icons-material/Sms';
import SpeakerNotesOff from '@mui/icons-material/SpeakerNotesOff';
import Star from '@mui/icons-material/Star';
import StarBorder from '@mui/icons-material/StarBorder';
import StarRate from '@mui/icons-material/StarRate';
import SupervisorAccount from '@mui/icons-material/SupervisorAccount';
import SupervisedUserCircle from '@mui/icons-material/SupervisedUserCircle';
import SwapVert from '@mui/icons-material/SwapVert';
import SyncAlt from '@mui/icons-material/SyncAlt';
import ThumbDown from '@mui/icons-material/ThumbDown';
import ThumbUp from '@mui/icons-material/ThumbUp';
import Timeline from '@mui/icons-material/Timeline';
import TrackChanges from '@mui/icons-material/TrackChanges';
import ViewHeadline from '@mui/icons-material/ViewHeadline';
import ViewList from '@mui/icons-material/ViewList';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Warning from '@mui/icons-material/Warning';

export const muiIcons = {
  AccessTime,
  Add,
  AddChartIcon,
  AddCircleOutline,
  AlarmOff,
  AndroidFilled,
  Announcement,
  Archive,
  AutoAwesome,
  Unarchive,
  ArrowBack,
  ArrowDownward,
  ArrowDropDown,
  ArrowDropUp,
  ArrowRight,
  ArrowUpward,
  Assessment,
  Ballot,
  BarChart,
  Block,
  BorderColor,
  Cached,
  CameraAlt,
  Cancel,
  Chat,
  ChatBubbleOutline,
  CheckBox,
  CheckBoxOutlineBlank,
  CheckCircle,
  CheckCircleOutline,
  ChevronLeft,
  ChevronRight,
  Close,
  ControlPointDuplicate,
  Dashboard,
  DateRange,
  Delete,
  Done,
  DragIndicator,
  Edit,
  EditOutlined,
  Email,
  Error,
  ErrorOutline,
  ExitToApp,
  FileCopy,
  FilterList,
  GetApp,
  Help,
  Info,
  InfoOutlinedIcon,
  InsertDriveFile,
  InsertDriveFileOutlinedIcon,
  KeyboardArrowDown,
  KeyboardArrowRight,
  Launch,
  LibraryAdd,
  LibraryAddCheck,
  LibraryBooks,
  ListAlt,
  LockOpen,
  NetworkCheck,
  NotificationsOff,
  Palette,
  People,
  PermContactCalendar,
  Person,
  PhoneDisabled,
  Photo,
  PlaylistAdd,
  Publish,
  RadioButtonUnchecked,
  RemoveCircleOutline,
  RemoveCircle,
  ReplayIcon,
  ReportProblemOutlined,
  ReportProblem,
  School,
  Search,
  Security,
  Send,
  SentimentSatisfied,
  SentimentSatisfiedAlt,
  SentimentVeryDissatisfied,
  Settings,
  SettingsBackupRestore,
  Sms,
  SpeakerNotesOff,
  Star,
  StarBorder,
  StarRate,
  SupervisorAccount,
  SupervisedUserCircle,
  SwapVert,
  SyncAlt,
  ThumbDown,
  ThumbUp,
  Timeline,
  TrackChanges,
  ViewHeadline,
  ViewList,
  Visibility,
  VisibilityOff,
  Warning,
};
